import React, { createContext, useState, useEffect, useRef } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { BYPASS_AUTH, mockUser } from '../config';
import { userService } from '../_services';

export const UserContext = createContext(null);

function UserProviderBypass({ children }) {
    const service = useRef(new userService()).current;
    const [user, setUser] = useState(null);

    useEffect(() => {
        service.getUserConnected()
            .then((res) => setUser(res.data))
            .catch(() => setUser(mockUser));
    }, []);

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

function UserProviderWithOkta({ children }) {
    const service = useRef(new userService()).current;
    const [user, setUser] = useState(null);
    const { authState, oktaAuth } = useOktaAuth();

    useEffect(() => {
        if (!authState || !authState.isAuthenticated) {
            setUser(null);
        } else {
            window.localStorage.setItem('urdg', authState.idToken.idToken);
            service.getUserConnected().then((res) => setUser(res.data));
        }
    }, [authState, oktaAuth]);

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

export const UserProvider = BYPASS_AUTH ? UserProviderBypass : UserProviderWithOkta;
